"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsReact = exports.Terms = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _store = require("../store");
var _AdditionalAgreements = require("./AdditionalAgreements");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TermsReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TermsReact, _React$Component);
  var _super = _createSuper(TermsReact);
  function TermsReact() {
    var _this;
    (0, _classCallCheck2.default)(this, TermsReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateCheckbox", function (name, value) {
      var field = (0, _defineProperty2.default)({}, name, value);
      var payload = _objectSpread({
        esignAgreementChecked: _this.props.document.esignAgreementChecked,
        applicationTermsAgreementChecked: _this.props.document.applicationTermsAgreementChecked,
        loanAgreementChecked: _this.props.document.loanAgreementChecked,
        isDocumentViewed: _this.props.document.isDocumentViewed
      }, field);
      _this.props.updateFormField(payload);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validateAndSubmitPage", function (e) {
      e.preventDefault();
      _this.props.validateAndSubmitInProgress();
      _this.props.validateAndSubmit();
    });
    return _this;
  }
  (0, _createClass2.default)(TermsReact, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        document = _this$props.document,
        siteInfo = _this$props.siteInfo;
      var navigationToNextPage = document.navigationToNextPage,
        error = document.error,
        loanAgreementChecked = document.loanAgreementChecked,
        bankCode = document.bankCode,
        disclosureCopy = document.disclosureCopy;
      var realm = siteInfo.realm,
        isSourceAspen = siteInfo.isSourceAspen,
        isSourceClearChoice = siteInfo.isSourceClearChoice;
      var loanAgreementClasses = (0, _classnames.default)('loanAgreement', {
        error: error && !loanAgreementChecked
      });
      var errorHTML = error && /*#__PURE__*/_react.default.createElement("div", {
        className: "error"
      }, error);
      var buttonClass = realm && realm === 'LCPS' ? 'lcps-button' : 'yts-button';
      var disclosureText = disclosureCopy && realm && disclosureCopy[realm] ? /*#__PURE__*/_react.default.createElement("span", null, disclosureCopy[realm][bankCode]) : null;
      var ctaButton = isSourceAspen || isSourceClearChoice ? 'e-Sign Loan Agreement' : 'I Agree';
      var loanAgreeId = 'loanAgreement';
      var buttonCtaId = 'buttonSubmitCta';
      var buttonHTML = navigationToNextPage === '' ? /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": buttonCtaId,
        id: "pf-esign-cta",
        className: buttonClass,
        type: "submit"
      }, ctaButton) : /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": buttonCtaId,
        id: "pf-esign-cta",
        className: buttonClass,
        onClick: this.validateAndSubmitPage,
        type: "submit"
      }, ctaButton);
      return /*#__PURE__*/_react.default.createElement("section", {
        id: "terms",
        className: "terms"
      }, /*#__PURE__*/_react.default.createElement("form", null, errorHTML, isSourceAspen && /*#__PURE__*/_react.default.createElement(_AdditionalAgreements.AdditionalAgreementsReact, {
        document: document,
        updateCheckbox: this.updateCheckbox
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "checkbox-wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: loanAgreementClasses,
        id: loanAgreeId,
        "data-test-id": loanAgreeId,
        name: loanAgreeId,
        value: loanAgreementChecked,
        onChange: function onChange() {
          _this2.updateCheckbox('loanAgreementChecked', !loanAgreementChecked);
        },
        type: "checkbox",
        checked: loanAgreementChecked,
        "aria-checked": loanAgreementChecked,
        "aria-invalid": error && !loanAgreementChecked,
        required: true
      }), /*#__PURE__*/_react.default.createElement("label", {
        id: "pf-esign-disclosure-check",
        htmlFor: "loanAgreement"
      }, disclosureText)), /*#__PURE__*/_react.default.createElement("div", {
        className: "agree-terms"
      }, buttonHTML)));
    }
  }]);
  return TermsReact;
}(_react.default.Component);
exports.TermsReact = TermsReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo,
    document: state.document
  };
};
TermsReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  document: _propTypes.default.object.isRequired,
  updateFormField: _propTypes.default.func.isRequired,
  validateAndSubmitInProgress: _propTypes.default.func.isRequired,
  validateAndSubmit: _propTypes.default.func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Terms = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TermsReact);
exports.Terms = Terms;
